import { anonymousId } from '@farmersdog/lead-browser-storage';

import { useSplitClient } from './useSplitClient';

export function useAnonymousIdSplitClient() {
  const anonymousIdValue = anonymousId.get();

  return useSplitClient(anonymousIdValue);
}
